module.exports = __webpack_public_path__ + "img/nt-back.9293d0a6.png";